$(document).ready(function () {
    //accordion slide and hide functionality
    $(".destination .destination__title").click(function () {
        $(this).toggleClass("active");
        if ($(this).next().hasClass("show_pan")) {
            $(this).next().slideUp();
            $(this).next().removeClass('show_pan');
        } else {
            $(this).next().slideDown();
            $(this).next().addClass('show_pan');
        }
    });

    //fliter functionality
    //mobile overlay
    let overlayOpen = false;
    $('.filter__btn__mobile').click(function () {
        $('.destination__alphabet__overlay').fadeIn(300);
        $('.destination__alphabet__overlay').click(function () {
            $('.destination__alphabet__overlay').fadeOut(300);
            $('body').css('overflow', 'initial');
            overlayOpen = false;
        });
        $('body').css('overflow', 'hidden');
        overlayOpen = true;
    });
    $('.destination__letter').click(function () {
        //checks if the overlay is opened (for mobile)
        if (overlayOpen) {
            $('.destination__alphabet__overlay').fadeOut(300);
            $('body').css('overflow', 'initial');
            overlayOpen = false;
        }
        //general checks and funcionality
        var current_character = $(this).attr("name").toLowerCase();
        var elements = [];
        $('.destination__letter').removeClass("active");
        $(this).addClass("active");
        $.each($('.destination'), function (index, value) {
            var attr = $(this).find('.destination__title h3').text().substr(0, 1).toLowerCase();
            $(value).fadeOut(300);
            if (attr == current_character) {
                $(value).fadeIn(300);
                elements.push(true);
            } else {
                elements.push(false);
            }
        });
        if (elements.includes(true)) {
            $('#empty__countries').hide();
        } else {
            $('#empty__countries').show();
        }
    });
    $('.all__destinations').click(function () {
        $('.destination').fadeIn(300);
        $('#empty__countries').hide();
        $('.destination__letter').removeClass("active");
    });


    //array of all swipers
    var contents = $('.des__airlines .swiper');
    //creating slider with airlines for each city with unique class
    $.each($(contents), function (index) {
        let cur_swiper_id = contents[index]['classList'][1];
        if ($('.swiper').hasClass(cur_swiper_id)) {
            const swiper = new Swiper(`.${cur_swiper_id}`, {
                // Optional parameters
                slidesPerView: 'auto',
                slidesPerGroupAuto: true,
                direction: 'horizontal',
                loop: false,
                autoResize: false,
                spaceBetween: 8,
                // Navigation arrows
                navigation: {
                    nextEl: `#${cur_swiper_id}_next`,
                    prevEl: `#${cur_swiper_id}_prev`,
                },
            });
        }
    });
});
